import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './WorkBanner.module.css';

interface WorkBannerProps {
  subtitle?: string;
  children?: ReactNode;
}

// PARA-105, AC-8: баннер «Поработаем?» — ручной триггер, без Bot API/push.
// PARA-122 (D13, AC-6): поддерживает subtitle и слот children (CTA «Мне лень»
// живёт внутри баннера) — образец components/tasks/WorkBanner.jsx.
export function WorkBanner({ subtitle, children }: WorkBannerProps): JSX.Element {
  const { t } = useTranslation('tasks');

  return (
    <div className={styles.banner} data-testid="work-banner">
      <div className={styles.title}>{t('workBanner')}</div>
      {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
      {children && <div className={styles.cta}>{children}</div>}
    </div>
  );
}
